export default "__VITE_ASSET__2ffe0e2b__"